<mat-card-content>
  <div style="max-height: 500px; overflow: auto;">
    <table mat-table [dataSource]="interestList" style="width: 100%;border-bottom: solid 1px rgba(0, 0, 0, 0.12);">
      <ng-container matColumnDef="pydlndStdday">
        <th mat-header-cell *matHeaderCellDef>検針年月日</th>
        <td mat-cell *matCellDef="let row">{{ row.pydlndStdday }}</td>
      </ng-container>
      <ng-container matColumnDef="dlineDate">
        <th mat-header-cell *matHeaderCellDef>支払期限日</th>
        <td mat-cell *matCellDef="let row">{{ row.payDlineDate }}</td>
      </ng-container>
      <ng-container matColumnDef="dryrskClgrltDate">
        <th mat-header-cell *matHeaderCellDef>猶予期限日</th>
        <td mat-cell *matCellDef="let row">{{ row.dryrskClgrltDate }}</td>
      </ng-container>
      <ng-container matColumnDef="rcvDate">
        <th mat-header-cell *matHeaderCellDef>領収日</th>
        <td mat-cell *matCellDef="let row">{{ row.rcvDate }}</td>
      </ng-container>
      <ng-container matColumnDef="rcvMny">
        <th mat-header-cell *matHeaderCellDef>領収金額</th>
        <td mat-cell *matCellDef="let row">{{ row.rcvMny }}</td>
      </ng-container>
      <ng-container matColumnDef="targetMny">
        <th mat-header-cell *matHeaderCellDef>対象金額</th>
        <td mat-cell *matCellDef="let row">{{ row.targetMny }}</td>
      </ng-container>
      <ng-container matColumnDef="delayRisoku">
        <th mat-header-cell *matHeaderCellDef>延滞利息金額</th>
        <td mat-cell *matCellDef="let row">{{ row.delayRisoku }}</td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
</mat-card-content>
